import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import makeRootReducer from "./rootReducer";
import injectReducers from "./injectReducers";

const initReducer = (state = {}, action) => {
  return state;
};

const initReducers = {
  init: initReducer,
};

const myStore = (initState = {}) => {
  const loggerMiddleware = (store) => (next) => (action) => {
    next(action);
  };
  const saga = createSagaMiddleware();
  let middleware = [saga, loggerMiddleware];
  const enhancers = [];
  let composeEnhancers = undefined;

  if (process.env.NODE_ENV !== "production") {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  } else {
    composeEnhancers = compose;
  }

  // composeEnhancers = compose;
  const store = createStore(
    makeRootReducer(initReducers),
    initState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  );
  // loadUser(store, userManager);

  store.asyncReducers = {};
  store.sagaMiddleware = saga;
  store.injectedEffects = {};

  store.attachSaga = (saga) => {
    store.sagaMiddleware.run(saga);
  };
  injectReducers(store);
  return store;
};

export default myStore;
